import React, { Fragment, useEffect, useState } from "react";
import { getQueryParams } from "../../helpers/helpers";
import Table from "../components/Table/Table";
import api from "../../services/api";
import serverHost from "../../services/serverHost";
import { CircularProgress, Container, Grid } from "@mui/material";

let musicasGeral = [];
let ciclosGeral = [];
let unidadesGeral = [];
let filtroCiclo = 0;
let filtroUnidade = 0;

export default function Musicas({ history, location }) {
  const [carregando, setCarregando] = useState(false);
  const [tabelaMusicas, setTabelaMusicas] = useState({});
  const [tabelasFiltros, setTabelasFiltros] = useState([]);

  useEffect(() => {
    setCarregando(true);

    api
      .get("ciclos/listarMusicas", { produto: 1 })
      .then((musicas) => {
        musicasGeral = musicas;
        configurarFiltros(musicas);
        montarTabela();
      })
      .catch((e) => console.log(e));
  }, []);

  const configurarFiltros = (musicas) => {
    const parametros = getQueryParams(location.search);

    musicas.forEach((m) => {
      if (
        m.cicloId &&
        ciclosGeral.filter((cg) => cg.id === m.cicloId).length === 0
      ) {
        ciclosGeral.push({ id: m.cicloId, nome: m.cicloNome });
      }

      if (
        m.unidadeId &&
        unidadesGeral.filter(
          (cg) => cg.id === m.unidadeId && cg.cicloId === m.cicloId
        ).length === 0
      ) {
        unidadesGeral.push({
          id: m.unidadeId,
          nome: `${m.unidadeNumero} - ${m.unidadeTitulo}`,
          cicloId: m.cicloId,
        });
      }
    });

    if (parametros.cic) filtroCiclo = Number(parametros.cic);
    if (parametros.uni) filtroUnidade = Number(parametros.uni);
  };

  const filtrar = ({ cicloId, unidadeId }) => {
    if (cicloId >= 0) {
      filtroCiclo = cicloId;
      filtroUnidade = 0;
    }
    if (unidadeId >= 0) {
      filtroUnidade = unidadeId;
    }

    const params = `?cic=${filtroCiclo}&uni=${filtroUnidade}`;

    history.push({
      pathname: location.pathname,
      search: params,
    });

    montarTabela();
  };

  const montarTabela = () => {
    const tabelasFiltros = [];

    const tbCiclos = {
      titulo: "Ciclos",
      data: [],
    };

    tbCiclos.data.push([
      <div
        key={0}
        className={`${filtroCiclo === 0 ? "btn-link-selecionado" : "btn-link"}`}
        onClick={() => filtrar({ cicloId: 0 })}
      >
        {"(Todos)"}
      </div>,
    ]);
    ciclosGeral.forEach((ciclo, key) => {
      tbCiclos.data.push([
        <div
          key={key}
          className={`${
            filtroCiclo === ciclo.id ? "btn-link-selecionado" : "btn-link"
          }`}
          onClick={() => filtrar({ cicloId: ciclo.id })}
        >
          {ciclo.nome}
        </div>,
      ]);
    });

    tabelasFiltros.push(tbCiclos);

    const tbUnidades = {
      titulo: "Unidades",
      data: [],
    };

    tbUnidades.data.push([
      <div
        key={0}
        className={`${
          filtroUnidade === 0 ? "btn-link-selecionado" : "btn-link"
        }`}
        onClick={() => filtrar({ unidadeId: 0 })}
      >
        {"(Todas)"}
      </div>,
    ]);

    unidadesGeral
      .filter((ug) => ug.cicloId === filtroCiclo)
      .forEach((unidade, key) => {
        tbUnidades.data.push([
          <div
            key={key}
            className={`${
              filtroUnidade === unidade.id ? "btn-link-selecionado" : "btn-link"
            }`}
            onClick={() => filtrar({ unidadeId: unidade.id })}
          >
            {unidade.nome}
          </div>,
        ]);
      });

    tabelasFiltros.push(tbUnidades);

    let musicasExibir = musicasGeral
      .filter((m) => (filtroCiclo ? m.cicloId === filtroCiclo : true))
      .filter((m) => (filtroUnidade ? m.unidadeId === filtroUnidade : true));

    const tbMusicas = {
      titulo: "Músicas - Bilíngue",
      data: [],
    };

    musicasExibir.forEach((musica) =>
      tbMusicas.data.push([
        musica.cicloNome,
        <div>
          Unidade {musica.unidadeNumero}
          <br />
          {musica.unidadeTitulo}
        </div>,
        <b>{musica.nome}</b>,
        musica.unidadeNome,
        <Play caminhoArquivo={musica.caminhoArquivo} />,
      ])
    );

    setTabelasFiltros(tabelasFiltros);
    setTabelaMusicas(tbMusicas);
    setCarregando(false);
  };

  const Play = ({ caminhoArquivo }) => {
    return (
      <audio
        preload="none"
        src={`${serverHost()}/${caminhoArquivo}`}
        controls="controls"
        controlsList="nodownload"
      />
    );
  };

  return (
    <Container maxWidth="lg" style={{ marginTop: 30 }}>
      <Grid
        container
        direction="row"
        justify="space-between"
        alignItems="center"
      >
        <h2>Músicas</h2>
      </Grid>
      {carregando ? (
        <Grid
          container
          style={{ marginBottom: 15, backgroundColor: "white", padding: 10 }}
        >
          <Grid item xs={12} style={{ textAlign: "center" }}>
            <CircularProgress />
          </Grid>
        </Grid>
      ) : (
        <Fragment>
          <Grid
            container
            style={{ marginBottom: 15, backgroundColor: "white", padding: 10 }}
          >
            {tabelasFiltros.map((tabela) =>
              tabela.data && tabela.data.length > 0 ? (
                <Grid item xs={12} md={4} style={{ textAlign: "center" }}>
                  <Table tableHead={[tabela.titulo]} tableData={tabela.data} />
                </Grid>
              ) : (
                <h5>Sem dados para exibir.</h5>
              )
            )}
          </Grid>
          {tabelaMusicas.data && tabelaMusicas.data.length > 0 ? (
            <Grid
              container
              style={{
                marginBottom: 15,
                backgroundColor: "white",
                padding: 10,
              }}
            >
              <Grid item xs={12} style={{ textAlign: "center" }}>
                <Table
                  tableHead={[tabelaMusicas.titulo]}
                  tableData={tabelaMusicas.data}
                />
              </Grid>
            </Grid>
          ) : (
            <h5>Sem músicas para exibir.</h5>
          )}
        </Fragment>
      )}
    </Container>
  );
}
